import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'
import _imports_1 from '../../assets/filter/chevron-left-solid.svg'
import _imports_2 from '../../assets/filter/chevron-right-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-c5b76070"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid row gap-5 p-0" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-download text-red",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "card d-flex p-6 gap-5"
}
const _hoisted_7 = {
  class: "col-12 d-flex flex-column p-0",
  style: {"font-size":"17px","overflow-x":"scroll"}
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<li style=\"border-radius:10px 10px 0px 0px;min-width:930px;border-bottom:0.5px solid #F3F3F3;\" class=\"col-12 p-3 d-flex flex-row\" data-v-c5b76070><span class=\"m-0 col-2 d-flex justify-content-center\" data-v-c5b76070>GRUPO</span><span class=\"m-0 col-2 d-flex justify-content-center\" data-v-c5b76070>LOJA</span><span class=\"m-0 col-2 d-flex justify-content-center\" data-v-c5b76070>USUAŔIO</span><span class=\"m-0 col-2 d-flex justify-content-center\" data-v-c5b76070>PLACA</span><span class=\"m-0 col-2 d-flex justify-content-center\" data-v-c5b76070>DATA</span><span class=\"m-0 col-2 d-flex justify-content-center\" data-v-c5b76070>AÇÂO</span></li>", 1)
const _hoisted_9 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_13 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_14 = { class: "col-2 d-flex gap-3 justify-content-center" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"color":"rgb(213 202 202)"} }, "Faça uma busca de relatório", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "pagination d-flex justify-content-between p-4"
}
const _hoisted_23 = { style: {"min-width":"14rem","display":"flex","flex-direction":"column","align-items":"start"} }
const _hoisted_24 = { style: {"font-size":"14px"} }
const _hoisted_25 = {
  key: 0,
  style: {"font-size":"14px"}
}
const _hoisted_26 = {
  class: "d-flex flex-row gap-2 align-items-center justify-content-between",
  id: "paginationList"
}
const _hoisted_27 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_28 = ["id", "disabled"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"12px"},
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick", "id"]
const _hoisted_32 = { class: "d-flex flex-row justify-content-start" }
const _hoisted_33 = {
  key: 0,
  id: "lastPage",
  class: "me-2"
}
const _hoisted_34 = ["id", "disabled"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"12px"},
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDetalheBuscaPlaca = _resolveComponent("ModalDetalheBuscaPlaca")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Relatório de busca placa")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          text: "Download",
          disabled: !_ctx.itemsOnPage.length,
          onClick: _ctx.downloadRelatorioBuscaPlaca
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_router_link, {
          to: "/lojas",
          style: {"height":"fit-content","white-space":"nowrap"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, { text: "Voltar" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.listaBuscaPlaca.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsOnPage, (item, key) => {
              return _withDirectives((_openBlock(), _createElementBlock("li", {
                class: "listaZebra col-12 d-flex flex-row align-items-center p-2",
                style: {"color":"#464e5f","min-width":"930px"},
                key: key
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(item.nomeGrupo), 1),
                _createElementVNode("span", {
                  class: "col-2 text-center text-truncate d-block",
                  title: item.nomeFantasia,
                  style: {"word-break":"break-all"}
                }, _toDisplayString(item.nomeFantasia), 9, _hoisted_10),
                _createElementVNode("span", {
                  class: "col-2 text-center text-truncate d-block px-4",
                  title: item.nomeUsuario
                }, _toDisplayString(item.nomeUsuario), 9, _hoisted_11),
                _createElementVNode("span", _hoisted_12, _toDisplayString(item.placa), 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(item.created_at), 1),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-light-danger",
                    onClick: ($event: any) => (_ctx.retornoBusca = item.retornoBusca, _ctx.openModal('ModalDetalheBuscaPlaca'))
                  }, _hoisted_17, 8, _hoisted_15)
                ])
              ])), [
                [_vShow, key >= (_ctx.state.currentPage - 1) * _ctx.state.itemsPerPage && key < _ctx.state.currentPage * _ctx.state.itemsPerPage]
              ])
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21)),
    (_ctx.listaBuscaPlaca.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, "Exibindo " + _toDisplayString(_ctx.itemsOnPage.length) + " buscas realizadas.", 1),
            (_ctx.listaBuscaPlaca.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, " Total de buscas feitas no período: " + _toDisplayString(_ctx.totalBuscas), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("ul", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "me-2",
                id: _ctx.state.currentPage === 1 ? 'btnPaginationOff' : 'btnPagination',
                disabled: _ctx.state.currentPage === 1,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage - 1)))
              }, _hoisted_30, 8, _hoisted_28),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginasNumeradas, (number, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, [
                  ((_ctx.state.currentPage < 4 ? key + 1 >= 1 && key + 1 <= 6 : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3) ||
                        (_ctx.pageCount - _ctx.state.currentPage < 4
                            ? key + 1 >= _ctx.pageCount - 6 && key + 1 <= _ctx.pageCount
                            : key + 1 >= _ctx.state.currentPage - 3 && key + 1 <= _ctx.state.currentPage + 3)
                        )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.setCurrentPage(number)),
                        class: "cursor-pointer",
                        id: number == _ctx.state.currentPage ? 'exibOk' : 'exibRed'
                      }, _toDisplayString(number), 9, _hoisted_31))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_ctx.pageCount !== _ctx.state.currentPage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                    _createTextVNode(" ... "),
                    _createElementVNode("span", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurrentPage(_ctx.pageCount))),
                      class: "ms-2 me-1 cursor-pointer"
                    }, _toDisplayString(_ctx.pageCount), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                id: _ctx.state.currentPage === _ctx.pageCount ? 'btnPaginationOff' : 'btnPagination',
                disabled: _ctx.state.currentPage === _ctx.pageCount,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurrentPage(_ctx.state.currentPage + 1)))
              }, _hoisted_36, 8, _hoisted_34)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalDetalheBuscaPlaca, { buscaDetalhada: _ctx.retornoBusca }, null, 8, ["buscaDetalhada"])
  ]))
}